// Stack — vertical / horizontal layout with token-spaced gaps.
// Replaces hand-rolled `style={{ display: flex, gap: 16 }}` everywhere.

import type { CSSProperties, HTMLAttributes, ReactNode } from "react";

import { tokens } from "../tokens/tokens";

type SpaceKey = keyof typeof tokens.space;

export interface StackProps extends HTMLAttributes<HTMLDivElement> {
  /** Direction. Default "column". */
  direction?: "row" | "column";
  /** Gap between children, by token key. Default 4 (16px). */
  gap?: SpaceKey;
  /** main-axis alignment. */
  justify?: CSSProperties["justifyContent"];
  /** cross-axis alignment. */
  align?: CSSProperties["alignItems"];
  /** Wrap horizontal stacks. Default false. */
  wrap?: boolean;
  /** Render children as is. */
  children?: ReactNode;
}

export function Stack({
  direction = "column",
  gap = 4,
  justify,
  align,
  wrap = false,
  style,
  children,
  ...rest
}: StackProps) {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: direction,
        gap: tokens.space[gap],
        justifyContent: justify,
        alignItems: align,
        flexWrap: wrap ? "wrap" : undefined,
        ...style,
      }}
      {...rest}
    >
      {children}
    </div>
  );
}
